@if (shouldDisplayRequiredError()) {
  <small class="error-info text-error">{{ errorMsg }}</small>
}
